import { render } from "./App.vue?vue&type=template&id=08c94bfe"
const script = {}

import "./App.vue?vue&type=style&index=0&id=08c94bfe&lang=scss"

import exportComponent from "/home/nootaku/dev/clickado_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__